/**
 * Created by denis.gusarov on 4/27/2017.
 */

namespace Factive.Game {

    import Tween = Factive.Core.Tween.Tween;
    import Easing = Factive.Core.Tween.Easing;
    import List = Factive.Core.Linq.List;
    import DependenciesContainer = Factive.Core.DependenciesContainer;
    import PixiTextureAtlasData = dragonBones.PixiTextureAtlasData;
    import PanelManager = Factive.Core.PanelManager;
    import LocalizationManager = Arkadium.Core.utils.LocalizationManager;
    import EventBus = Factive.Core.EventBus;
    import ArenaHelper = Arkadium.Game.ArenaHelper;
    import AnalyticsManager = Arkadium.Core.AnalyticsManager;
    import StorageManager = Factive.Core.StorageManager;
    import StorageManagerConstants = Factive.Core.StorageManagerConstants;
    import LocalizationConstants = Arkadium.Game.Localization.LocalizationConstants;

    export class GameMain extends GameBase {

        private $model: ISampleModel;
        private _background: PIXI.extras.TilingSprite;
        private _versionLabel: PIXI.Text;
        private _intro: IntroScreen;
        private _room: Factive.Game.GameRoom;
        private _panelManager: PanelManager;

        public constructor(dependenciesContainer: DependenciesContainer,
                           private options) {
            super(dependenciesContainer, options.element);

            this.$model = this.options.model;

            // because Internet Explorer does not use Math.log2()
            Math["log2"] = Math.log2 || function(x) {
                return Math.log(x) / Math.LN2;
            };
        }

        public static factory: any = {
            get (dependenciesContainer, options): GameMain {
                let gameMain = new GameMain(dependenciesContainer, options);
                let autotest = dependenciesContainer.get("Autotest", {
                    root: gameMain
                });
                return gameMain;
            },
            dependency: ["DependenciesContainer", "Options"],
            singleton: true
        };

        // protected onPIXIApplicationCreated():void
        // {
        //     //this.initializeManagers();
        // }


        private _contetntLoaded:boolean = false;
        protected onContentLoaded() {
            this._contetntLoaded = true;

            super.onContentLoaded();

            if(this._intro)
            {
                this._intro.signal.add(this.handlePressPlay, this);
                this._intro.startInteract();

                this.dc.get("GameAutoTestingManager").init(this.handlePressPlay.bind(this));
            }
        }

        private handlePressPlay(): void {
            this._intro.signal.remove(this.handlePressPlay, this);

            this._versionLabel.visible = false;

            this.getLayer(1).visible = true;
            this.getLayer(2).visible = true;

            this._room.startNewGame();

            //let that = this;
            let alpha = {a:0};
            let tweenPosition = new Tween(alpha)
                .to({a: 1}, 1000)
                .easing(Easing.Cubic.InOut);
            tweenPosition.onUpdate(() =>{
                this.getLayer(1).alpha = alpha.a;
                this.getLayer(2).alpha = alpha.a;
                this.getLayer(3).alpha = 1 - alpha.a;
            });
            tweenPosition.onComplete(() => {
                this._intro.destroy();
                this.getLayer(3).removeChildren();

            });
            tweenPosition.start();
        }

        protected onCreate(): void {
            //this.setModel(this.options.model, true);
        }

        // public setModel(model: ISampleModel, isInit: boolean = false): void {
        //
        //     var that = this;
        //     that.$model = model;
        //     this.clear();
        // }

        protected getConfiguration(): any {
            return {
                /*childViews:{
                 GameView:{
                 view: "MainMenuView",
                 options: {}
                 }
                 }*/
            };
        }

        protected onSetLandscape(): void {

            if(this._room) {
                this._aspectRatio = "landscape";
                this._room.changeAspectRatio("landscape");
            }
        }

        protected onSetPortrait(): void {

            if(this._room) {
                this._aspectRatio = "portrait";
                this._room.changeAspectRatio("portrait");
            }
        }

        protected onUpdate(): void {
        }

        protected onInitialize()
        {
            this.getLayer(1).visible = false;
            this.getLayer(2).visible = false;

            this._panelManager = new PanelManager(this.dc);
            this._panelManager.initialize(this.getLayer(2), "");
            this.dc.singleton("PanelManager", this._panelManager);

            this._room = new GameRoom(this.dc, this.getLayer(1), this);
            this._room.initialize();

            this.rendererResize(true);
        }

        protected rendererResize(force = false) {
            super.rendererResize(force);

            if (this._background) {
                this._background.width = this.renderer.width;
                this._background.height = this.renderer.height;
            }

            if (this._versionLabel) {
                this._versionLabel.x = this.renderer.width * 0.5 - this._versionLabel.width;
                this._versionLabel.y = this.renderer.height * 0.5 - this._versionLabel.height;
            }

            if(this._room) {
                this._room.resize(this.renderer.width, this.renderer.height);
            }

            if (this._panelManager) {
                this._panelManager.resize(this.renderer.width, this.renderer.height, this._aspectRatio);
            }
        }

        protected onIncLoadIndex(): void {
            this._intro.IncLoadIndex();
        }

        protected createIntro(): void {
            var BG_TILE_BASE_64: string = "data:image/png;base64,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";
            var tile = PIXI.Texture.fromImage(BG_TILE_BASE_64);
            this._background = new PIXI.extras.TilingSprite(
                tile,
                this.renderer.width,
                this.renderer.height
            );
            this._background.anchor.set(.5, .5);
            this.getLayer(0).addChild(this._background);

            var gameVersion = this.dc.get("Version");
            var md = this.dc.get("MobileDetect");
            var fontSize = 14;

            if(md.phone()) {
                fontSize = 24;
            }

            if(md.tablet()) {
                fontSize = 22;
            }

            this._versionLabel = new PIXI.Text(["v", gameVersion.match(/\d+.\d+.\d+/)[0]].join(""), <PIXI.TextStyle>{
                fontFamily: 'Medium',
                fontSize: fontSize * this.dc.get("AssetScale"),
                fill: '#FFFFFF',
                align:"center"
            });
            this._versionLabel.anchor.set(0.5, 0.5);
            this._versionLabel.x = this.renderer.width * 0.5 - this._versionLabel.width;
            this._versionLabel.y = this.renderer.height * 0.5 - this._versionLabel.height;

            this.getLayer(0).addChild(this._versionLabel);

            this._intro = new IntroScreen(this.dc);
            this.getLayer(3).addChild(this._intro);
            this.getLayer(3).alpha = 1;

            this.getLayer(1).visible = false;
            this.getLayer(2).visible = false;

            this._intro.build();

            // if(this._contetntLoaded)
            // {
            //     this._intro.signal.add(this.handlePressPlay, this);
            //     this._intro.startInteract();
            // }
        }

        public restart(): void {
            this._room.destroy();
            this._room = null;

            this._room = new GameRoom(this.dc, this.getLayer(1), this);
            this._room.initialize();

            this.createIntro();
            this.onContentLoaded();

            this.rendererResize(true);
        }
    }
}


// WEBPACK FOOTER //
// src/typescript/Game/GameMain.ts